import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // Import App
import "./index.css"; // Optional: CSS imports
import "leaflet/dist/leaflet.css"; // Global import for the entire app

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
